import { render, staticRenderFns } from "./ArticleFive.vue?vue&type=template&id=9db47a1e&scoped=true"
import script from "./ArticleFive.vue?vue&type=script&lang=js"
export * from "./ArticleFive.vue?vue&type=script&lang=js"
import style0 from "./ArticleFive.vue?vue&type=style&index=0&id=9db47a1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9db47a1e",
  null
  
)

export default component.exports